import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import $ from "jquery";
import logo from "../../../../src/assets/admin/img/logos/astro-adi-logo1.png";
import { useTranslation } from "react-i18next";
import * as dashboardServices from "../services/dashboard.services"; // Import services
import { SOCKET_CLIENT, authenticateSocket } from "../../../utils/socket";
import { getUser } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();
  const [badges, setBadges] = useState({
    return_requests: 0,
    pending_pujas: 0,
  });

  const [unreadSupportCount, setUnreadSupportCount] = useState(0);

  useEffect(() => {
    // Fetch badge counts
    dashboardServices
      .getSidebarBadges()
      .then((res) => {
        if (res.data) {
          setBadges(res.data);
          if (res.data.unread_support_chats !== undefined) {
            setUnreadSupportCount(res.data.unread_support_chats);
          }
        }
      })
      .catch(console.error);

    const admin = getUser(ROLE.SUPER_ADMIN);
    if (admin?.token) {
      authenticateSocket(admin.token);
    }

    const handleUnreadCount = (data) => {
      if (data?.unread_count !== undefined) {
        setUnreadSupportCount(data.unread_count);
      }
    };

    const handleNewAdminMsg = () => {
      dashboardServices.getSidebarBadges().then((res) => {
        if (res.data?.unread_support_chats !== undefined) {
          setUnreadSupportCount(res.data.unread_support_chats);
        }
      }).catch(console.error);
    };

    SOCKET_CLIENT.on("unread_support_count", handleUnreadCount);
    SOCKET_CLIENT.on("new_support_message_admin", handleNewAdminMsg);

    return () => {
      SOCKET_CLIENT.off("unread_support_count", handleUnreadCount);
      SOCKET_CLIENT.off("new_support_message_admin", handleNewAdminMsg);
    };
  }, [loc.pathname]); // Refresh on route change

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.parentElement;
    if (dropDown.classList.contains("show")) {
      dropDown.classList.remove("show");
    } else {
      dropDown.classList.add("show");
    }
  };

  const hoverSidebar = (e) => {
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = (e) => {
    $("body").removeClass("main-sidebar-open");
  };

  return (
    <div
      className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y"
      id="app_sidebar"
      onMouseEnter={hoverSidebar}
      onMouseLeave={removeHoverSidebar}
    >
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          <img
            src={logo}
            className="header-brand-img icon-logo admin-logo"
            alt="logo"
            style={{ height: "1.6rem" }}
            id="logo_short"
          />
          <img
            src={logo}
            className="header-brand-img desktop-logo admin-logo rounded"
            style={{ height: "4.3rem" }}
            alt="logo"
            id="logo_full"
          />
        </a>
      </div>
      {/* Dashboard section start */}
      <div className="main-sidebar-body">
        <ul className="nav">
          {/* ... existing items ... */}
          <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/dashboard" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/dashboard">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-home sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_dashboard")}
              </span>
            </Link>
          </li>
          {/* Dashboard section end */}

          {/* Revenue Dashboard section start */}
          {/* <li
            className={
              "nav-item" + (loc.pathname === "/admin/revenue" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/revenue">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-chart-line sidemenu-icon"></i>
              <span className="sidemenu-label">Revenue Report</span>
            </Link>
          </li> */}
          {/* Revenue Dashboard section end */}

          {/* Analytics Reports section start */}
          {/* <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/analytics-reports" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/analytics-reports">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-chart-bar sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Analytics Reports")}</span>
            </Link>
          </li> */}
          {/* Analytics Reports section end */}

          {/* Live Consultation Monitor section start */}
          {/* <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/live-consultation-monitor"
                ? " active"
                : "")
            }
          >
            <Link className="nav-link" to="/admin/live-consultation-monitor">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-video sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Live Consultation")}</span>
            </Link>
          </li> */}

          {/* User section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/user-management")
                ? "show active"
                : "")
            }
          >
            <Link className="nav-link" to="/admin/user-management/user/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-user-tie sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Users")}</span>
            </Link>
          </li>

          {/* user section end */}

          {/* astrologer section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/astrologer-management")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-user-astronaut sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Astrologers")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes(
                      "/admin/astrologer-management/astrologer",
                    )
                      ? "active"
                      : "")
                  }
                  to="/admin/astrologer-management/astrologer/list/1"
                >
                  Astrologer
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes(
                      "/admin/astrologer-management/ai-astrologer",
                    )
                      ? "active"
                      : "")
                  }
                  to="/admin/astrologer-management/ai-astrologer/list/1"
                >
                  AI Astrologer
                </Link>
              </li>
            </ul>
          </li>
          {/* astrologer section end */}

          {/* ratings section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/rating") ? "show active" : "")
            }
          >
            <Link className="nav-link" to="/admin/rating/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-star sidemenu-icon"></i>
              <span className="sidemenu-label">Ratings & Reviews</span>
            </Link>
          </li>
          {/* ratings section end */}

          {/* verification requests section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/verification") ? "show active" : "")
            }
          >
            <Link className="nav-link" to="/admin/verification/list">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-user-check sidemenu-icon"></i>
              <span className="sidemenu-label">Verification Requests</span>
            </Link>
          </li>
          {/* verification requests section end */}

          {/* horoscope package section start */}
          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/package")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to="/admin/package/list/1"
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-box-open sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Horoscope Packages")}</span>
            </Link>
          </li> */}
          {/* horoscope package section end */}

          {/* astrologer consultations section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/consultation")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-calendar-check sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Consultations")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/consultation/list")
                      ? "active"
                      : "")
                  }
                  to="/admin/consultation/list/1"
                >
                  Consultations List
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/consultation/reschedules")
                      ? "active"
                      : "")
                  }
                  to="/admin/consultation/reschedules"
                >
                  Reschedule Consultations
                </Link>
              </li>
            </ul>
          </li>
          {/* astrologer consultations section end */}

          {/* Transaction section start */}

          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/payable-transaction") || loc.pathname.includes("/payout-transaction")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-money-bill-wave sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Transaction")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${loc.pathname.includes("/payable-transaction") ? "active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/payable-transaction/list/1`}
                >
                  Payable transaction
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/payout-transaction") ? "active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/payout-transaction/list/1`}
                >
                  Payout Transaction
                </Link>
              </li>
            </ul>
          </li> */}

          {/* Transaction section end */}

          {/* Cms section start */}
          <li
            className={
              `nav-item ` + (loc.pathname.includes("/cms") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-edit sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/banner") ? " active" : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/banner/list/${1}`}
                >
                  {t("Banners")}
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/pages") ? " active" : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/pages/list/${1}`}
                >
                  {t("sidebar_link_pages")}
                </Link>
              </li>
              {/* <li
                className={`nav-sub-item ${loc.pathname.includes("/cms/service-offer") ? " active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/service-offer/add`}
                >
                  {t("Service Offers")}
                </Link>
              </li> */}
              {/* <li
                className={`nav-sub-item ${loc.pathname.includes("/cms/learn-hub") ? " active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/learn-hub/list/${1}`}
                >
                  Courses & Webinars
                </Link>
              </li> */}
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/faq") ? " active" : ""
                }`}
              >
                <Link className="nav-sub-link" to={`/admin/cms/faq/list/${1}`}>
                  FAQ
                </Link>
              </li>
              {/* <li
                className={`nav-sub-item ${loc.pathname.includes("/cms/services") ? " active" : ""
                  }`}
              >
                <Link className="nav-sub-link" to={`cms/services/list/1`}>
                  Services
                </Link>
              </li> */}
              <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/default-email-template")
                    ? " active"
                    : "")
                }
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/default-email-template/list/${1}`}
                >
                  {t("sidebar_link_email_template")}
                </Link>
              </li>

              {/* email-announcement */}
              {/* <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/email-announcement")
                    ? " active"
                    : "")
                }
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/email-announcement`}
                >
                  {t("Email Announcement")}
                </Link>
              </li> */}

              {/* notification-announcement */}
              {/* <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/notification-announcement")
                    ? " active"
                    : "")
                }
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/notification-announcement`}
                >
                  {t("Notification Announcement")}
                </Link>
              </li> */}

              {/* <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/web-home") ? " active" : "")
                }
              >
                <Link className="nav-sub-link" to={`/admin/cms/web-home`}>
                  {t("Website Home")}
                </Link>
              </li> */}

              {/* <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/about-us") ? " active" : "")
                }
              >
                <Link className="nav-sub-link" to={`/admin/cms/about-us`}>
                  {t("About Us")}
                </Link>
              </li> */}

              <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/settings") ? " active" : "")
                }
              >
                <Link className="nav-sub-link" to={`/admin/cms/settings`}>
                  {t("sidebar_link_global_settings")}
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/admin/video") ? " active" : ""
                }`}
              >
                <Link className="nav-sub-link" to={`/admin/video/list/${1}`}>
                  {t("Videos")}
                </Link>
              </li>
            </ul>
          </li>
          {/* Cms section end */}

          {/* Category section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/puja-category")
                ? "show active"
                : "")
            }
          >
            <Link className="nav-link" to={`/admin/puja-category/list/1`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-th-large sidemenu-icon"></i>
              <span className="sidemenu-label">Categories</span>
            </Link>
          </li>
          {/* Category section end */}

          {/* App Menu Configuration start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/app-menu-category") ||
              loc.pathname.includes("/admin/app-menu-item")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-bars sidemenu-icon"></i>
              <span className="sidemenu-label">App Menu Config</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/app-menu-category")
                      ? "active"
                      : "")
                  }
                  to="/admin/app-menu-category/list"
                >
                  Categories (Tabs)
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/app-menu-item")
                      ? "active"
                      : "")
                  }
                  to="/admin/app-menu-item/list"
                >
                  Menu Items
                </Link>
              </li>
            </ul>
          </li>
          {/* App Menu Configuration end */}

          {/* Notification */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/notification")
                ? "show active"
                : "")
            }
          >
            <Link className="nav-link" to={`/admin/notification`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-bell sidemenu-icon"></i>
              <span className="sidemenu-label">Notifications</span>
            </Link>
          </li>

          {/* subscription section start */}

          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/subscription") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-credit-card sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_subscription")}
              </span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/subscription-plan")
                  ? " active"
                  : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/subscription-plan/list/1`}
                >
                  Subscription Plan
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/transaction") ? " active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/transaction/list/1`}
                >
                  Transaction
                </Link>
              </li>
            </ul>
          </li>

          {/* subscription section end */}

          {/* testimonial management section end */}
          {/* <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/testimonial-management")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/testimonial-management/testimonial/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-comment-dots sidemenu-icon"></i>
                <span className="sidemenu-label">
                {t("sidebar_link_testimonials")}
                </span>
              </Link>
            </li> */}
          {/* testimonial management section end */}

          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/inquiry")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to={`/admin/inquiry/list/${1}`}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Advisor Inquiry")}
              </span>
            </Link>
          </li> */}

          {/*  Contact Us section  */}
          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/contact-us")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to={`/admin/contact-us/list/${1}`}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-address-card sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_contact_us")}
              </span>
            </Link>
          </li> */}
          {/*  Contact Us section end */}

          {/* Remedies sart  */}
          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/remedies-management")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to={`/admin/remedies-management/remedies/list/1`}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-gem sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Ecommerce")}</span>
            </Link>
          </li> */}
          {/* Remedies end */}

          {/* Report section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/report") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-file-alt sidemenu-icon"></i>
              <span className="sidemenu-label">Reports</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/report/list") ||
                    loc.pathname.includes("/admin/report/add") ||
                    loc.pathname.includes("/admin/report/edit")
                      ? "active"
                      : "")
                  }
                  to="/admin/report/list/1"
                >
                  Report Master
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/report/booking-list")
                      ? "active"
                      : "")
                  }
                  to="/admin/report/booking-list/1"
                >
                  Personalized Reports
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/report-price")
                      ? "active"
                      : "")
                  }
                  to="/admin/report-price/list/1"
                >
                  Report Price
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/report/question-bookings")
                      ? "active"
                      : "")
                  }
                  to="/admin/report/question-bookings/list/1"
                >
                  Question Bookings
                </Link>
              </li>
            </ul>
          </li>
          {/* Report section end */}

          {/* Transfer start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/withdrawal") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-wallet sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Transfers")}
                {badges.pending_withdrawals > 0 && (
                  <span className="badge bg-info ms-2">
                    {badges.pending_withdrawals}
                  </span>
                )}
              </span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname === "/admin/withdrawal/manual-list"
                      ? "active"
                      : "")
                  }
                  to="/admin/withdrawal/manual-list"
                >
                  Manual Transfer
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname === "/admin/withdrawal/manual-history"
                      ? "active"
                      : "")
                  }
                  to="/admin/withdrawal/manual-history"
                >
                  Transfer History
                </Link>
              </li>
            </ul>
          </li>
          {/* Transfer end */}

          {/* Payment Management start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/payment-management")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-file-invoice-dollar sidemenu-icon"></i>
              <span className="sidemenu-label" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", maxWidth: "140px", verticalAlign: "middle" }}>
                {t("Payment Management")}
              </span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              {/* <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname === "/admin/payment-management/summary" ? "active" : "")
                  }
                  to="/admin/payment-management/summary"
                >
                  Summary
                </Link>
              </li> */}
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes(
                      "/admin/payment-management/wallet-history",
                    )
                      ? "active"
                      : "")
                  }
                  to="/admin/payment-management/wallet-history/1"
                >
                  Wallet History
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes(
                      "/admin/payment-management/gateway-payments",
                    )
                      ? "active"
                      : "")
                  }
                  to="/admin/payment-management/gateway-payments/1"
                >
                  Gateway Payments
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes(
                      "/admin/payment-management/order-payments",
                    )
                      ? "active"
                      : "")
                  }
                  to="/admin/payment-management/order-payments/1"
                >
                  Order Payments
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes(
                      "/admin/payment-management/consultation-payments",
                    )
                      ? "active"
                      : "")
                  }
                  to="/admin/payment-management/consultation-payments/1"
                >
                  Consultation Payments
                </Link>
              </li>
            </ul>
          </li>
          {/* Payment Management end */}

          {/* Order start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/order/") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/order/list/1`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-shopping-basket sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Orders")}
                {badges.return_requests > 0 && (
                  <span className="badge bg-danger ms-2">
                    {badges.return_requests}
                  </span>
                )}
              </span>
            </Link>
          </li>
          {/* Order end */}

          {/* Product section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/product-category") ||
              loc.pathname.includes("/product-attribute") ||
              loc.pathname.includes("/product-attribute-value") ||
              loc.pathname.includes("/product-rating") ||
              loc.pathname.includes("/admin/product/")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-shopping-bag sidemenu-icon"></i>
              <span className="sidemenu-label">Product</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/product/list") ||
                    loc.pathname.includes("/admin/product/add") ||
                    loc.pathname.includes("/admin/product/edit")
                      ? "active"
                      : "")
                  }
                  to="/admin/product/list/1"
                >
                  Product List
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/product-rating")
                      ? "active"
                      : "")
                  }
                  to="/admin/product-rating/list/1"
                >
                  Product Ratings
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/product-category") ? "active" : "")
                  }
                  to="/admin/product-category/list/1"
                >
                  Product Category
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/product-attribute")
                      ? "active"
                      : "")
                  }
                  to="/admin/product-attribute/list/1"
                >
                  Product Attribute
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/product-attribute-value")
                      ? "active"
                      : "")
                  }
                  to="/admin/product-attribute-value/list/1"
                >
                  Attribute Value
                </Link>
              </li>
            </ul>
          </li>
          {/* Product section end */}

          {/* Puja section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/puja-booking") ||
              loc.pathname.includes("/puja-type") ||
              loc.pathname.includes("/admin/puja/")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-pray sidemenu-icon"></i>
              <span className="sidemenu-label">Puja</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/puja-booking")
                      ? "active"
                      : "")
                  }
                  to="/admin/puja-booking/list/1"
                >
                  {t("Puja Bookings")}
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/puja/reschedules")
                      ? "active"
                      : "")
                  }
                  to="/admin/puja/reschedules"
                >
                  Reschedule Puja
                </Link>
              </li>
              <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/admin/puja/list") ||
                    loc.pathname.includes("/admin/puja/add") ||
                    loc.pathname.includes("/admin/puja/edit")
                      ? "active"
                      : "")
                  }
                  to="/admin/puja/list/1"
                >
                  Pujas
                </Link>
              </li>
              {/* <li className="nav-sub-item">
                <Link
                  className={
                    `nav-sub-link ` +
                    (loc.pathname.includes("/puja-type") ? "active" : "")
                  }
                  to="/admin/puja-type/list/1"
                >
                  {t("Puja Types")}
                </Link>
              </li> */}
            </ul>
          </li>
          {/* Puja section end */}

          {/* Feedback start */}
          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/feedback") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/feedback/list/1`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-comment-dots sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Feedback")}</span>
            </Link>
          </li> */}
          {/* Feedback end */}

          {/*  Chat Support section start  */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/chat-support") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/chat-support`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-comments sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Chat Support")}
                {unreadSupportCount > 0 && (
                  <span className="badge bg-danger rounded-pill ms-2" style={{ fontSize: "11px", fontWeight: "bold", verticalAlign: "middle" }}>
                    {unreadSupportCount}
                  </span>
                )}
              </span>
            </Link>
          </li>
          {/*  Chat Support section end */}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
